import alt from 'components/Dispatcher';
import { hashHistory } from 'react-router';
let $ = window.$;
class PorderActions{
  fetchPorders() {
    return true;
  }
  updatePorders(status,porders) {
    return {status,porders};
  }
  fetchPorder(id) {
    return id;
  }
  updatePorder(res) {
    if(res.status) {
      this.fetchError(res);
      return false;
    } else {
      return res.result;
    }
  }
  fetchLoading() {
    return {loading: true};
  }
  setData(data){
    return data;
  }
  fetchSuccess(res) {
    if(res.status) {
      this.fetchError(res);
    } else {
      let status = res.tag;
      this.updatePorders(status,res.result);
    }
    return true;
  }
  fetchError(res) {
    if(res.status === 403) {
      hashHistory.push('/login');
    }
    return true;
  }
  refreshPorder() {
    return true;
  }
}

export default alt.createActions(PorderActions);



// WEBPACK FOOTER //
// ./src/actions/PorderActions.js